import type { Language } from '../../i18n/translations.js';
import { DEMO_COPY } from './demo-copy.js';
export function BusinessLinkStage({
  language,
  step,
  go,
}: {
  readonly language: Language;
  readonly step: number;
  readonly go: (next: number) => void;
}) {
  const c = DEMO_COPY[language];
  return (
    <section
      className="stage mw-stage mw-link-stage"
      id="stage-0"
      aria-labelledby="business-title"
      hidden={step !== 0}
    >
      <div className="mw-stage-heading">
        <h3 id="business-title" tabIndex={-1}>
          {c.helpMoujaUnderstandYourBusiness}
        </h3>
        <p>{c.aWebsiteInstagramOrTiktokLink}</p>
      </div>
      <div className="mw-setup-grid">
        <div className="mw-link-panel">
          <div className="mw-field-label">
            <label htmlFor="sample-url">{c.linkIconLabel}</label>
            <span className="mw-small-tag">{c.preparedExample}</span>
          </div>
          <div className="mw-url-field">
            <svg
              aria-hidden="true"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
            >
              <path d="M10 13a5 5 0 0 0 7 .2l3-3a5 5 0 0 0-7-7l-2 2M14 11a5 5 0 0 0-7-.2l-3 3a5 5 0 0 0 7 7l2-2"></path>
            </svg>
            <input
              id="sample-url"
              type="url"
              value="https://nurtelia.example"
              readOnly
              aria-describedby="demo-disclosure"
            />
          </div>

          <button
            className="btn mw-target"
            id="use-business"
            type="button"
            onClick={() => {
              go(1);
            }}
          >
            <span className="cs-px3" aria-hidden="true">
              <i></i>
              <i></i>
              <i></i>
            </span>
            <span>{c.useThisLink}</span>
          </button>
        </div>
        <div className="mw-store-preview">
          <div className="mw-store-top">
            <span className="mw-store-wordmark">{'NURTELIA'}</span>
          </div>
          <div className="mw-cookie-display">
            <span className="mw-cookie-orbit" aria-hidden="true"></span>
            <img
              src="/landing-demo/cookie.png"
              alt={c.dropSelected}
              width="240"
              height="240"
            />
          </div>
          <div className="mw-store-bottom">
            <strong>{c.cookiesWithCharacter}</strong>
          </div>
        </div>
      </div>
    </section>
  );
}
